import React, { FC } from 'react';
import { Button, useWasOpenedByWindowOpen, X } from 'shared-components';

export const CloseWindowButtonStyled: FC<{
  version: 'white' | 'black';
  xProps?: React.SVGProps<SVGSVGElement> & { stroke?: string; pathProps?: React.SVGProps<SVGPathElement> };
}> = ({ version, xProps = {} }) => {
  const isOpenedInWindow = useWasOpenedByWindowOpen();
  return isOpenedInWindow ? (
    <Button
      type="button"
      aria-label="Close"
      className="rounded-[9999px] bg-[#D8D8D8] border-[#9E9E9E] hover:bg-[#9E9E9E] w-[40px] h-[40px] p-0 m-0 flex items-center justify-center"
      onClick={() => window.close()}
    >
      <X
        width="40"
        height="40"
        pathProps={{
          fill: version === 'black' ? 'black' : 'white',
        }}
        {...xProps}
      />
    </Button>
  ) : null;
};
